export default __webpack_public_path__ + "static/media/img9.8a6358f0.jpg";